import entities from "../../api/entities";

// List or item action for deleting entity or entities
export default class {
  constructor({ root, self, entity_type }, { entity, entities }) {
    this.root = root;
    this.entity_type = entity_type;
    this.self = self;

    this.id_or_ids = entity.id || entities.map(a => a.id);
  }
  async execute() {
    // TODO: request dialog with callback

    console.log(
      "deleteAction.execute",
      this.root,
      this.self,
      this.entity_type,
      this.id_or_ids
    );
    if (confirm(`Удалить запись(и) ${this.id_or_ids} навсегда?`)) {
      const response = await entities.delete(
        this.root.token,
        this.entity_type,
        this.id_or_ids
      );
      if (response.success) {
        this.root.$emit("reload_entities");
        this.root.$emit("notify", "Запись(и) успешно удалена(ы)", "green");
      } else
        this.root.$emit(
          "notify",
          response.message || "Не удалось удалить запись(и)",
          "red"
        );
      if (response.more) console.error(response.more);
    }
  }
}
